const sortValues = ['datumUverejnenia', 'nazovPredpisuSort', 'zoznamTypov'];
const defaultSort = 'datumUverejnenia';

export {
  sortValues, defaultSort,
};
